var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 80,
    viewBox: "0 0 148 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.003 14.9379L110.973 22.4686L117.716 27.7938L123.003 14.9379Z",
    fill: "#4C18ED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.1238,
    cy: 32.4589,
    r: 24.1854,
    fill: "#DBD1FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.852 50.9167C101.852 79.0372 73.9454 77.3297 45.8249 77.3297C17.7044 77.3297 0.0185547 79.0372 0.0185547 50.9167C0.0185547 22.7962 22.8147 0 50.9352 0C79.0557 0 101.852 22.7962 101.852 50.9167Z",
    fill: "#DBD1FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.807 5.0918L98.0332 18.4574H106.625L102.807 5.0918Z",
    fill: "#4C18ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.667 38.9603L100.537 37.733",
    stroke: "#4C18ED",
    strokeWidth: 1.90937,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.536 45.1393L113.308 42.0516",
    stroke: "#4C18ED",
    strokeWidth: 1.90937,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.792 56.8226C37.0371 54.1904 33.4807 53.4791 30.8485 55.2339C28.2162 56.9887 27.505 60.5452 29.2598 63.1774L38.792 56.8226ZM70.965 74.147L71.1965 79.8704L70.965 74.147ZM117.463 62.6593C120.609 62.9905 123.428 60.7085 123.76 57.5623C124.091 54.4161 121.809 51.5972 118.663 51.266L117.463 62.6593ZM29.2598 63.1774C34.2225 70.6214 41.7934 74.8842 49.317 77.2243C56.8447 79.5656 64.7648 80.1306 71.1965 79.8704L70.7335 68.4236C65.2261 68.6463 58.6767 68.1378 52.7195 66.2849C46.7583 64.4308 41.8293 61.3786 38.792 56.8226L29.2598 63.1774ZM71.1965 79.8704C78.0403 79.5936 83.0348 77.9632 87.1096 75.518C90.927 73.2273 93.8542 70.1962 96.0089 68.2279C98.2925 66.1419 100.315 64.5865 103.204 63.5762C106.143 62.5482 110.471 61.9232 117.463 62.6593L118.663 51.266C110.539 50.4109 104.411 51.0174 99.4221 52.7621C94.3829 54.5244 91.0047 57.2826 88.2822 59.7695C85.4309 62.3741 83.7468 64.1753 81.2149 65.6946C78.9405 67.0595 75.8477 68.2167 70.7335 68.4236L71.1965 79.8704Z",
    fill: "#4C18ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 46.0088V46.0088C132.259 47.2717 134.749 53.3856 131.832 57.9996V57.9996",
    stroke: "#A3A1AD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.774 43.4189V43.4189C138.085 44.6818 140.575 50.7958 137.658 55.4097V55.4097",
    stroke: "#A3A1AD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.6205d3a3.svg";
export { ForwardRef as ReactComponent };